import { render, staticRenderFns } from "./InterfaceLayout.vue?vue&type=template&id=1f9495e2&scoped=true&"
import script from "./InterfaceLayout.vue?vue&type=script&lang=js&"
export * from "./InterfaceLayout.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceLayout.vue?vue&type=style&index=0&id=1f9495e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9495e2",
  null
  
)

export default component.exports